import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="bg-cream py-10 px-6 md:py-16" data-id="element-202">
      <div className="max-w-3xl mx-auto" data-id="element-203">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-4 text-lg leading-relaxed" data-id="element-204">
          <h2 className="font-playfair text-3xl md:text-4xl text-charcoal mb-5" data-id="element-205">
            Depuis le divorce, quelque chose a changé.
          </h2>

          <p data-id="element-206">
            Et ce n'est pas seulement la maison, le budget, ou le regard des
            autres.
          </p>

          <p className="text-xl font-semibold text-burgundy" data-id="element-207">C'est TOI.</p>

          <p data-id="element-208">Tu es devenue une machine à survivre.</p>

          <p data-id="element-209">
            Chaque matin, tu te lèves avant tout le monde. Tu prépares les
            lunchs. Tu règles les conflits. Tu gères les messages de l'ex qui
            arrivent au mauvais moment. Tu souris à tout le monde alors que tu
            portes le poids du monde sur tes épaules.
          </p>

          <p data-id="element-210">Et le soir, quand tout le monde est couché...</p>

          <p className="text-xl font-semibold" data-id="element-211">
            Il ne reste plus rien pour toi.
          </p>

          <p data-id="element-212">
            Pas d'énergie. Pas de joie. Pas même l'envie de prendre soin de toi.
          </p>

          <p data-id="element-213">
            Tu t'es regardée dans le miroir ce matin. Et tu ne t'es pas
            reconnue.
          </p>

          <p data-id="element-214">Pas parce que tu as vieilli.</p>

          <p className="text-xl font-semibold text-burgundy" data-id="element-215">
            Mais parce que tu t'es oubliée.
          </p>

          <p data-id="element-216">Et le pire dans tout ça ?</p>

          <p data-id="element-217">Tu culpabilises même d'avoir envie de te retrouver.</p>

          <p data-id="element-218">
            Comme si prendre du temps pour toi était un luxe que tu ne mérites
            pas. Comme si "être une bonne maman" signifiait s'effacer
            complètement en tant que femme.
          </p>

          <p className="text-2xl font-playfair text-burgundy pt-3" data-id="element-219">
            Ce mensonge t'a déjà coûté assez cher.
          </p>
        </motion.div>
      </div>
    </section>;
}